import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, Link } from 'react-router-dom';
import { signUpUserStart } from './../../redux/User/user.actions';
import './styles.scss';
import ReactLoading from 'react-loading'

import AuthWrapper from './../AuthWrapper';
import FormInput from '../forms/FormInput';
import Button from '../forms/Button';

const mapState = ({ user }) => ({
  currentUser: user.currentUser,
  userErr: user.userErr
});

const Signup = props => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { currentUser, userErr } = useSelector(mapState);
  const [firstName, setfirstName] = useState('');
  const [lastName, setlastName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [errors, setErrors] = useState([]);
  const [click, setClick] = useState(false);

  const handleClick = () => setClick(!click);

  const [click1, setClick1] = useState(false);


  useEffect(() => {
    if (currentUser) {
      reset();
      history.push('/');
    }

  }, [currentUser]);

  useEffect(() => {
    if (Array.isArray(userErr) && userErr.length > 0) {
      setErrors(userErr);
      setClick(false)
    }

  }, [userErr]);

  const reset = () => {
    setfirstName('');
    setlastName('');
    setEmail('');
    setPhone('');
    setPassword('');
    setConfirmPassword('');
    setErrors([]);
  };

  const handleChecker = () => {
    setClick1(true)
  };

  const handleFormSubmit = event => {
    if (click1 == true) {
      event.preventDefault();
      dispatch(signUpUserStart({
        lastName,
        firstName,
        email,
        phone,
        password,
        confirmPassword
      }));
    }
    else{
      console.log("error")
    }
  }




  const configAuthWrapper = {
    headline: 'Registration'
  };

  return (
    <AuthWrapper {...configAuthWrapper}>
      <div className="formWrap">

        <span className="txt">
          Create your own Account
        </span>

        {errors.length > 0 && (
          <ul className="err" >
            {errors.map((err, index) => {
              return (
                <li key={index}>
                  {err}
                </li>
              );
            })}
          </ul>
        )}

        <form onSubmit={handleFormSubmit}>

          <div className="each-input">
            <FormInput
              type="text"
              name="fname"
              value={firstName}
              placeholder="First Name"
              handleChange={e => setfirstName(e.target.value)}
            />

            <FormInput
              type="text"
              name="lname"
              value={lastName}
              placeholder="Last Name"
              handleChange={e => setlastName(e.target.value)}
            />
          </div>

          <div className="each-input">
            <FormInput
              type="tel"
              name="phone"
              value={phone}
              placeholder="Phone Number"
              handleChange={e => setPhone(e.target.value)}
            />

            <FormInput
              type="email"
              name="email"
              value={email}
              placeholder="Email"
              handleChange={e => setEmail(e.target.value)}
            />

          </div>

          <div className="each-input">
            <FormInput
              type="password"
              name="password"
              value={password}
              placeholder="Password"
              handleChange={e => setPassword(e.target.value)}
            />

            <FormInput
              type="password"
              name="confirmPassword"
              value={confirmPassword}
              placeholder="Confirm Password"
              handleChange={e => setConfirmPassword(e.target.value)}
            />
          </div>

          <div className="checkbox-container">
            <label className="container">
              <span>
                I accept the <span className="coloring">Terms & Conditions</span>
                <br />
                and Privacy and Cookie Notice
              </span>
              <input type="checkbox" id="tandc" name="tandc" value="checked" onClick={handleChecker} />
              <span className="checkmark">
              </span>
            </label>

            <label className="container">
              <span>
                I want to recieve Newsletters with the best deals and offers
              </span>
              <input type="checkbox" id="tandc" name="tandc" value="" />
              <span className="checkmark checked">
              </span>
            </label>

          </div>

          <Button type="submit" onClick={handleClick}>
          <span className={click ? 'span active' : 'span'}>
              Register
            </span>
            <ReactLoading className={click ? 'loader' : 'loader active'} type="bubbles" color={"#fff"} height={20} width={80} />
          </Button>
        </form>

        <div className="links flex">
          <li>
            <Link to="/">
              Continue Shopping
            </Link>
          </li>

          <li>

            <span>Already Have An Account? </span>
            <Link to="/signin">
              Signin
            </Link>
          </li>
        </div>

        <div className="btm-hint">
          <h5 className="semi-bold">Sign up today and you'll be able to :</h5>
          <ul className="list-unstyled list-benefits">
            <li><svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 64 64">
              <path d="M59.712 20.224q0 1.408-1.024 2.432l-30.72 30.72q-1.024 0.96-2.432 0.96t-2.432-0.96l-17.792-17.792q-0.96-1.024-0.96-2.432t0.96-2.432l4.864-4.864q1.024-1.024 2.432-1.024t2.432 1.024l10.496 10.56 23.424-23.488q1.024-1.024 2.432-1.024t2.432 1.024l4.864 4.864q1.024 0.96 1.024 2.432z"></path>
            </svg>Speed your way through the checkout</li>
            <li><svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 64 64">
              <path d="M59.712 20.224q0 1.408-1.024 2.432l-30.72 30.72q-1.024 0.96-2.432 0.96t-2.432-0.96l-17.792-17.792q-0.96-1.024-0.96-2.432t0.96-2.432l4.864-4.864q1.024-1.024 2.432-1.024t2.432 1.024l10.496 10.56 23.424-23.488q1.024-1.024 2.432-1.024t2.432 1.024l4.864 4.864q1.024 0.96 1.024 2.432z"></path>
            </svg>Track your orders easily</li>
            <li><svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 64 64">
              <path d="M59.712 20.224q0 1.408-1.024 2.432l-30.72 30.72q-1.024 0.96-2.432 0.96t-2.432-0.96l-17.792-17.792q-0.96-1.024-0.96-2.432t0.96-2.432l4.864-4.864q1.024-1.024 2.432-1.024t2.432 1.024l10.496 10.56 23.424-23.488q1.024-1.024 2.432-1.024t2.432 1.024l4.864 4.864q1.024 0.96 1.024 2.432z"></path>
            </svg>Keep a record of all your purchases</li>
          </ul>
        </div>
      </div>
    </AuthWrapper>
  );
}

export default Signup;
